import { IPortin } from "../ICart";

export interface IPortinResponse {
    otherNetworkAccountNumber: string | undefined;
    otherNetworkId: number | undefined;
    otherNetworkName: string;
    type: string;
    portStartDateTime: string;
    msisdn: string;
}

export const getResponseToState = (response: IPortinResponse): IPortin => ({
    otherNetworkAccountNumber: response.otherNetworkAccountNumber,
    otherNetworkId: response.otherNetworkId,
    otherNetworkName: response.otherNetworkName,
    phoneNumber: response.msisdn,
    portStartDateTime: response.portStartDateTime,
    type: response.type,
});
